import {on} from 'delegated-events'
import {addThrottledInputEventListener, removeThrottledInputEventListener} from '../throttled-input'

// When a user clicks on a suggested custom instruction, add it to the custom instructions prompt
on('click', '.js-copilot-suggested-custom-instruction', function (event) {
  event.preventDefault()
  const target = event.target as HTMLElement
  const wrapper = target.closest('.js-copilot-custom-instructions-wrapper')
  if (!wrapper) {
    return
  }
  const customInstructionPrompt = wrapper.querySelector<HTMLTextAreaElement>(
    '.js-copilot-custom-instructions-wrapper textarea',
  )
  const suggestionTextAttr = 'data-copilot-custom-instructions-suggestion-text'
  // The user may click a span within the suggested text element. So we can't
  // use event.target directly. Instead, we want to get the closest parent
  // element with the attribute so we can get the suggested text.
  const suggestion = target.closest(`[${suggestionTextAttr}]`)

  if (customInstructionPrompt && suggestion) {
    const currentValue = customInstructionPrompt.value
    const suggestedText = suggestion.getAttribute(suggestionTextAttr)
    if (suggestedText) {
      const newValue = currentValue ? `${currentValue}\n- ${suggestedText}` : `- ${suggestedText}`
      customInstructionPrompt.value = newValue
      // Make sure a prompt change is triggered so that the character count is updated and discard button is enabled
      onPromptChange(customInstructionPrompt)
      // Scroll text area to the bottom so that the new suggestion is visible
      customInstructionPrompt.scrollTop = customInstructionPrompt.scrollHeight
    }
  }
})

// When page loads, update the character counter
document.addEventListener('turbo:load', function () {
  const customInstructionPrompts = document.querySelectorAll<HTMLTextAreaElement>(
    '.js-copilot-custom-instructions-wrapper textarea',
  )
  for (const prompt of customInstructionPrompts) {
    updateCharacterCounter(prompt)
  }
})

// Set up character counter updates
on('focusin', '.js-copilot-custom-instructions-wrapper textarea', event => {
  const field = event.target as HTMLTextAreaElement
  // Listening to keyup events is not allowed. So we must use this throttled listener which is more perfomant.
  addThrottledInputEventListener(field, onPromptChange, {wait: 20})
  field.addEventListener('blur', () => removeThrottledInputEventListener(field, onPromptChange), {once: true})
})

function onPromptChange(input: HTMLInputElement | HTMLTextAreaElement) {
  // When prompt is changed, enable the "Discard changes" button
  const discardButton = document.querySelector<HTMLButtonElement>('.js-copilot-discard-custom-instructions')
  discardButton?.removeAttribute('disabled')

  // Then update the character counter
  updateCharacterCounter(input as HTMLTextAreaElement)
}

function updateCharacterCounter(promptInput: HTMLTextAreaElement) {
  const wrapper = promptInput.closest('.js-copilot-custom-instructions-wrapper')
  if (!wrapper) {
    return
  }
  const currentCharacterCountText = wrapper.querySelector<HTMLSpanElement>(
    '.js-copilot-custom-instructions-character-count',
  )

  if (currentCharacterCountText) {
    currentCharacterCountText.textContent = promptInput.value.length.toString()

    const characterLimit = parseInt(promptInput.getAttribute('data-copilot-custom-instructions-character-limit')!, 10)
    // The characterCounter is the whole counter (e.g.  "5 / 600")
    const characterCounter = wrapper.querySelector<HTMLSpanElement>(
      '.js-copilot-custom-instructions-character-counter',
    )!
    if (promptInput.value.length > characterLimit) {
      // Mark character count as red if over the limit
      characterCounter.classList.add('fgColor-danger')
    } else {
      // Remove red if under the limit
      characterCounter.classList.remove('fgColor-danger')
    }
  }
}

on('click', '.js-copilot-discard-custom-instructions', function (event) {
  event.preventDefault()
  window.location.reload()
})
